export const searchResults = state => state.items.itemInventory.search;
export const loading = state => state.items.itemInventory.loading;
export const currentPage = state =>
  state.items.itemInventory.pagination.page || 1;
export const totalResults = state =>
  state.items.itemInventory.pagination.total || 0;
export const pageSize = state => state.items.itemInventory.pagination.pageSize;
export const totalPages = state =>
  Math.ceil(totalResults(state) / pageSize(state));
